import { createContext } from 'react'

export const ListingContext = createContext({})
export const CalendarContext = createContext({})
